import { computed, shallowRef } from 'vue';

/**
 * The top-bar «Asistente» pill (plan §9.4). It lives inside the app bar,
 * whose `contain: layout` and z-index trap fixed descendants, so the
 * coachmark anchored to it renders at the app root and finds it here; the
 * panel gives the focus back to it on close.
 */
const pill = shallowRef<HTMLElement | null>(null);

export const assistantPill = computed(() => pill.value);

export function setAssistantPill(element: HTMLElement | null): void {
  pill.value = element;
}

/** Forgets `element` unless another pill registered since. */
export function clearAssistantPill(element: HTMLElement | null): void {
  if (pill.value === element) pill.value = null;
}
